import styled from 'styled-components';

export const ReturnPolicyModalWrapper = styled.div`
  background: ${props => props.theme.carvana.gray.background};
  padding: 34px;
`;

export const P = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${props => props.theme.carvana.gray.dark};
  margin: 0 0 20px 0;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const TermsAndConditions = styled.div`
  ${P} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const SevenDayReturn = styled.img`
  display: block;
  margin: 0 auto 20px;
`;

export const TermsLink = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
  color: ${props => props.theme.carvana.blue.primary};
  cursor: pointer;
`;
